exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dropdown-menu a{color:black;font-weight:bold}.dropdown-menu:before{border:0 !important}.dropdown-menu:after{border:0 !important}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/BulkMail/bulk-mail.scss
// module id = 1871
// module chunks = 32